import request from "../../utils/http-client"

export const loadPlanStatus = (
  endpoint = ""
): Promise<void | {
  currentStatus?: string
  otherStatuses?: {}
}> => {
  return request({
    url: endpoint,
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    }
  }).then((res) => {
    if (res.data) {
      return (
        {
          currentStatus: res.data.currentStatus,
          otherStatuses: res.data.otherStatuses
        } || {}
      )
    }
  })
}

export const postPlanStatus = (
  currentStatus,
  planComments,
  endpoint = ""
): Promise<void | {
  currentStatus?: string
  planComments?: string
  endpoint?: string
  newStatusItem?: {}
}> => {
  return request({
    url: endpoint,
    method: "post",
    data: {
      ["status_update"]: {
        status: currentStatus,
        comment: planComments,
        date: new Date().toString()
      }
    },
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content")
    }
  }).then((res) => {
    if (res.data) {
      return (
        {
          newStatusItem: res.data.status
        } || {}
      )
    }
  })
}
